package com.fantasytenis.shared.core.network

import io.ktor.client.engine.*
import io.ktor.client.engine.js.*

/**
 * Web (JS) implementation uses Js (fetch API) engine.
 */
actual fun createHttpClientEngine(): HttpClientEngine {
    return Js.create()
}
